import {selectNavOption} from "../helpers/nav_option_helpers";

export default function selectNavOptionWhenReturningToMapFilter(sm, navOption) {
    // Note that we're not calling `handleNavOptionSelection` as might be expected.
    // That *should* be the correct course of action, however this would engage the router based on the URL.
    // And because the user is returning from a Nav pane option that has no URL change (yet!) eg. Introduction pane.
    // Then the URL will not have changed from the last map filter. Therefore the router will not see a route change and will not trigger any handlers.
    // So we need to bypass the router and directly call the `selectNavOption` function.
    // TODO - All nav options should change the url!
    selectNavOption(sm, navOption);
}
